<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Customers</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Customers</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="p-4">
            <h3>Customers</h3>
          </div>

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-basic-tab" data-toggle="tab" href="#_active" role="tab"
                aria-controls="_active" aria-selected="true" @click="handleResetFilter()">Active</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-basic-tab" data-toggle="tab" href="#_inactive" role="tab"
                aria-controls="_inactive" aria-selected="false" @click="handleResetFilter()">Inactive</a>
            </li>
          </ul>

          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active bg-white" id="_active" role="tabpanel"
              aria-labelledby="individual-tab">
              <div class="card-body">
                <div class="form-group">
                  <label for="filter">Filter based on</label>
                  <div style="display: inline; position: relative">
                    <div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input " type="radio" name="filterOption" id="lastLoginRadio"
                          :checked="tempFilter.type === 1" @change="tempFilter.type = 1">
                        <label class="form-check-label " for="lastLoginRadio" style="margin-bottom: 0;">Last
                          Login</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="filterOption" id="disableSoonRadio"
                          :checked="tempFilter.type === 2" @change="tempFilter.type = 2">
                        <label class="form-check-label" for="disableSoonRadio" style="margin-bottom: 0;">Disable
                          Soon</label>
                      </div>
                    </div>
                    <small class="text-danger" style="position: absolute; top: 45px;">{{ filterMessage.type }}</small>
                  </div>
                </div>
                <div class="form-inline" style="margin-bottom: 10px;">
                  <div class="form-group" style="margin-right: 15px; vertical-align: middle;">
                    <label for="lastLoginDate" style="margin-right: 5px;">{{ tempFilter.type == 1 ? 'Last Login' :
                      'Within'
                    }}</label>
                    <div style="display: inline-block; position: relative;">
                      <TextInput :modelValue="tempFilter.value" type="number" id="lastLoginValue" style="width: 180px;"
                        :onChange="(e) => handleChangeValue(e.target.value)" />
                      <small class="text-danger" style="position: absolute; top: 40px;">{{ filterMessage.value
                      }}</small>
                    </div>
                  </div>

                  <div class="form-group" style="margin-right: 15px; vertical-align: middle;">
                    <div style="position: relative;;">
                      <SelectionComponent v-model="tempFilter.period" :currentlySelected="tempFilter.period"
                        :options="periodOptions" style="width: 150px;"
                        @change="(e) => handleChangePeriod(e.target.value)" />
                      <small class="text-danger" style="position: absolute; top: 40px;">{{ filterMessage.period
                      }}</small>
                    </div>
                  </div>
                  <p style="display: inline-block; margin: 0 15px 0 0; vertical-align: middle;">{{ tempFilter.type == 1
                    ?
                    'ago or longer' : 'to be disabled' }}</p>

                  <button class="btn btn-primary btn-rounded" style="margin-right: 10px; width: 150px;"
                    @click="handleFilter('active')">Filter</button>
                  <button class="btn btn-primary btn-rounded" style="width:150px;"
                    @click="handleResetFilter()">Reset</button>
                </div>
                <div class="d-flex flex-row p2 mb-2 justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <json-excel class="btn btn-rounded btn-primary mr-1" style="width: 150px" :fetch="activeData"
                      :fields="activeFields" type="csv" worksheet="My Worksheet" name="Active Customers.csv">
                      Excel
                    </json-excel>
                    <button class="btn btn-success btn-rounded btn-block" style="width: 150px;"
                      @click="handleResetAll('active')">Reset
                      All</button>
                    <div class="" style="display: inline-block; margin-left: 24px;">
                      <Tooltip>
                        <div>
                          <p>
                            <strong>"Reset All"</strong> feature will reset the account validity of the filtered
                            list at
                            once based on the currently defined disabled period
                            (e.g. <em>365 days / 1 year</em>) when clicked.
                          </p>
                          <ul style="margin-bottom: 0;">
                            <li>The <strong>"Last Logout"</strong> timestamp will be changed to current timestamp.
                            </li>
                            <li>The logs will be recorded and displayed under the <strong>"Account Status Logs"</strong>
                              table
                              on the Customer Details page.</li>
                            <li>
                              <strong>Impact:</strong> If the user is currently logged in, they will be logged out from
                              the
                              TBM app and required to log in again.
                            </li>
                          </ul>


                        </div>

                      </Tooltip>
                    </div>

                  </div>
                  <div class="d-flex flex-row">
                    <div class="form-outline">
                      <input type="input" v-model="searchItem" class="form-control" />
                    </div>
                    <button type="button" @click="searchFor('active')" class="btn btn-primary">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>


                <div class="table-responsive">
                  <table id="customers_tbl" class="display table table-striped table-bordered"
                    style="width: 100%; text-align: center">
                    <thead>
                      <tr>
                        <!-- <th>No.</th> -->
                        <th>IC No.</th>
                        <th>Mobile No.</th>
                        <th>Username</th>
                        <th>Email</th>
                        <th>Verified</th>
                        <th>Declined Reason</th>
                        <th>Last Login</th>
                        <th>Last Logout</th>
                        <th>Reactivated on</th>
                        <th>Reset on</th>
                        <th>Action <span>
                            <Tooltip position="left">
                              <p>
                                <strong>"Reset Account"</strong> feature will reset the account validity of the selected
                                user based on
                                the currently defined disabled period (e.g.
                                365 days / 1 year) when clicked.
                              </p>
                              <ul style="margin-bottom: 0;">
                                <li>The <strong>"Last Logout"</strong> timestamp will be changed to current timestamp.
                                </li>
                                <li>The logs will be recorded and displayed under the <strong>"Account Status
                                    Logs"</strong> table on the
                                  Customer Details page.</li>
                                <li>
                                  <strong>Impact</strong>: If the user is currently logged in, they will be logged out
                                  from the TBM app
                                  and required to log in again.
                                </li>
                              </ul>
                            </Tooltip>
                          </span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-show="customers.length == 0">
                        <td colspan="11" class="text-center">No Data.</td>
                      </tr>
                      <tr v-for="(customer, index) in customers" v-bind:key="index">
                        <!-- <td>{{ index + 1 }}</td> -->
                        <td>{{ customer.ic_number }}</td>
                        <td>{{ customer.mobile_number }}</td>
                        <td>{{ customer.username }}</td>
                        <td>{{ customer.email }}</td>
                        <td>
                          <span>{{
                            customer.email_verified_at !== null ? "Yes" : "No"
                          }}</span>
                        </td>
                        <td>
                          <span>
                            {{ customer.declined_reason }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ customer.last_login }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ customer.last_logout }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ customer.reactivated_on }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ customer.reset_at }}
                          </span>
                        </td>
                        <td>
                          <button v-if="customer.email_verified_at === null" @click="verifyCustomer(customer.id)"
                            class="btn btn-success btn-rounded btn-block">
                            Verify Customer
                          </button>
                          <button v-if="
                            customer.email_verified_at === null &&
                            customer.declined_at === null
                          " @click="declineVerificationModal(customer)" class="btn btn-danger btn-rounded btn-block">
                            Decline Verification
                          </button>
                          <button @click="
                            customerDetails(
                              customer.id,
                              customer.ic_number,
                              customer.email,
                              customer.created_at
                            )
                            " class="btn btn-success btn-rounded btn-block" style="
                              background-color: #ac8400;
                              border-color: #ac8400;
                            ">
                            View Details
                          </button>
                          <button class="btn btn-success btn-rounded btn-block"
                            @click="resetAccount(customer.id, 'active')">
                            Reset Account
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <pagination v-model="pageInfo.current_page" :per-page="pageInfo.per_page" :records="pageInfo.total"
                    @paginate="handlePageChange" />
                </div>
              </div>
            </div>
            <div class="tab-pane fade bg-white" id="_inactive" role="tabpanel" aria-labelledby="multiple-tab">
              <div class="card-body">
                <div class="form-inline" style="margin-bottom: 10px;">
                  <div class="form-group" style="margin-right: 15px; vertical-align: middle;">
                    <label for="lastLoginDate" style="margin-right: 5px;">Last Login</label>
                    <div style="display: inline-block; position: relative;">
                      <TextInput :modelValue="tempFilter.value" type="number" id="lastLoginValue" style="width: 180px;"
                        :onChange="(e) => handleChangeValue(e.target.value)" />
                      <small class="text-danger" style="position: absolute; top: 40px;">{{ filterMessage.value
                      }}</small>
                    </div>
                  </div>

                  <div class="form-group" style="margin-right: 15px; vertical-align: middle;">
                    <div style="position: relative;;">
                      <SelectionComponent v-model="tempFilter.period" :currentlySelected="tempFilter.period"
                        :options="periodOptions" style="width: 150px;"
                        @change="(e) => handleChangePeriod(e.target.value)" />
                      <small class="text-danger" style="position: absolute; top: 40px;">{{ filterMessage.period
                      }}</small>
                    </div>
                  </div>

                  <p style="display: inline-block; margin: 0 15px 0 0; vertical-align: middle;">ago or longer</p>

                  <button class="btn btn-primary btn-rounded" style="margin-right: 10px; width: 150px;"
                    @click="handleFilter('inactive')">Filter</button>
                  <button class="btn btn-primary btn-rounded" style="width:150px;"
                    @click="handleResetFilter()">Reset</button>
                </div>
                <div class="d-flex flex-row p2 mb-2 justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <json-excel class="btn btn-rounded btn-primary mr-1" style="width: 150px" :fetch="inactiveData"
                      :fields="inactiveFields" type="csv" worksheet="My Worksheet" name="Inactive Customers.csv">
                      Excel
                    </json-excel>
                    <button class="btn btn-success btn-rounded btn-block" style="width: 150px;"
                      @click="reactivateAllAccounts()">Reactivate All</button>
                    <div class="" style="display: inline-block; margin-left: 24px;">
                      <Tooltip>
                        <p>
                          <strong>"Reactivate All"</strong> feature will reactivate all the inactive/disabled accounts
                          at once when
                          clicked.
                        </p>
                        <ul style="margin-bottom: 0;">
                          <li>It will reset the account validity of the users based on the currently defined disabled
                            period (e.g. 365 days / 1 year).
                          </li>
                          <li>The account status will be changed to Active.</li>
                          <li>
                            The <strong>"Last Logout"</strong> timestamp will be changed to current timestamp.
                          </li>
                          <li>
                            The logs will be recorded and displayed under the <strong>"Account Status Logs"</strong>
                            table on the
                            Customer Details page.
                          </li>
                        </ul>
                      </Tooltip>
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div class="form-outline">
                      <input type="input" v-model="searchItem2" class="form-control" />
                    </div>
                    <button type="button" @click="searchFor2" class="btn btn-primary">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div class="table-responsive" style="overflow: visible;">
                  <table id="customers_tbl" class="display table table-striped table-bordered"
                    style="width: 100%; text-align: center;">
                    <thead>
                      <tr>
                        <!-- <th>No.</th> -->
                        <th>IC No.</th>
                        <th>Mobile No.</th>
                        <th>Username</th>
                        <th>Email</th>
                        <th>Verified</th>
                        <th>Declined Reason</th>
                        <th>Last Login</th>
                        <th>Last Logout</th>
                        <th style="position: relative;">Action <span>
                            <Tooltip position="left">
                              <p>
                                <strong>"Reactivate Account"</strong> feature will reactivate the selected
                                inactive/disabled account when
                                clicked.
                              </p>
                              <ul style="margin-bottom: 0;">
                                <li>It will reset the account validity of the user based on the currently defined
                                  disabled period (e.g. 365 days / 1 year).
                                </li>
                                <li> The account status will be changed to Active.</li>
                                <li>
                                  The <strong>"Last Logout"</strong> timestamp will be changed to current timestamp.
                                </li>
                                <li>
                                  The logs will be recorded and displayed under the <strong>"Account Status
                                    Logs"</strong> table on the
                                  Customer Details page.
                                </li>
                              </ul>
                            </Tooltip>
                          </span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-show="inactiveCustomers.length == 0">
                        <td colspan="9" class="text-center">No Data.</td>
                      </tr>
                      <tr v-for="(customer, index) in inactiveCustomers" v-bind:key="index">
                        <!-- <td>{{ index + 1 }}</td> -->
                        <td>{{ customer.ic_number }}</td>
                        <td>{{ customer.mobile_number }}</td>
                        <td>{{ customer.username }}</td>
                        <td>{{ customer.email }}</td>
                        <td>
                          <span>{{
                            customer.email_verified_at !== null ? "Yes" : "No"
                          }}</span>
                        </td>
                        <td>
                          <span>
                            {{ customer.declined_reason }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ customer.last_login }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ customer.last_logout }}
                          </span>
                        </td>
                        <td>
                          <button v-if="customer.email_verified_at === null" @click="verifyCustomer(customer.id)"
                            class="btn btn-success btn-rounded btn-block">
                            Verify Customer
                          </button>
                          <button v-if="
                            customer.email_verified_at === null &&
                            customer.declined_at === null
                          " @click="declineVerificationModal(customer)" class="btn btn-danger btn-rounded btn-block">
                            Decline Verification
                          </button>
                          <button @click="
                            customerDetails(
                              customer.id,
                              customer.ic_number,
                              customer.email,
                              customer.created_at
                            )
                            " class="btn btn-success btn-rounded btn-block" style="
                              background-color: #ac8400;
                              border-color: #ac8400;
                            ">
                            View Details
                          </button>
                          <button class="btn btn-success btn-rounded btn-block" @click="
                            enableAccount(customer.id, customer.disabled_id)
                            ">
                            Reactivate Account
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <pagination v-model="pageInfo2.current_page" :per-page="pageInfo2.per_page" :records="pageInfo2.total"
                    @paginate="handlePageChange2" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" id="thisModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Decline {{ user.email }}?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <label for="reason">Decline reason:</label>
            <textarea name="reason" id="reason" v-model="reason" cols="30" rows="10" class="form-control"></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="declineVerification()">
              Decline
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";
import { getRequest, postRequest } from "@/services/RequestService";
import TextInput from "../../../components/TextInput.vue";
import SelectionComponent from "../../../components/UI/SelectionComponent.vue";
import Tooltip from "../../../components/UI/Tooltip.vue";

export default {
  name: "customers",
  components: {
    Pagination,
    Loading,
    JsonExcel,
    TextInput,
    SelectionComponent,
    Tooltip,
  },

  data() {
    return {
      user: {},
      reason: "",
      customers: [],
      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0,
      },

      inactiveCustomers: [],
      pageInfo2: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0,
      },

      isLoading: false,
      fullPage: true,
      searchItem: null,

      searchItem2: null,

      // Export columns follow the table columns of each tab
      activeFields: {
        "Name": "full_name",
        "Email": "email",
        "Username": "username",
        "IC Number": "ic_number",
        "Registered At": "created_at",
        "Phone No": "mobile_number",
        "DOB": "date_of_birth",
        "Gender": "gender",
        "Last Login": "last_login",
        "Last Logout": "last_logout",
        "Verified": "email_verified",
        "Declined Reason": "declined_reason",
        "Reactivated on": "reactivated_on",
        "Reset on": "reset_at",
      },
      inactiveFields: {
        "Name": "full_name",
        "Email": "email",
        "Username": "username",
        "IC Number": "ic_number",
        "Registered At": "created_at",
        "Phone No": "mobile_number",
        "DOB": "date_of_birth",
        "Gender": "gender",
        "Last Login": "last_login",
        "Last Logout": "last_logout",
        "Verified": "email_verified",
        "Declined Reason": "declined_reason",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      mainApi: `${axios.baseURL2}/customer/all?active=1`,
      downloadApi: `${axios.baseURL2}/customer/all?active=1&export=1`,

      mainInApi: `${axios.baseURL2}/customer/all?disabled=1`,
      downloadInactiveApi: `${axios.baseURL2}/customer/all?disabled=1&export=1`,

      data: {
        day: null,
        dayInactive: null
      },

      periodOptions: [{ value: 1, name: 'Days' }, { value: 2, name: 'Weeks' }, { value: 3, name: 'Months' }],
      filter: {
        period: 0,
        type: 0,
        value: null,
      },
      tempFilter: {
        period: 0,
        type: 0,
        value: null,
      },
      filterMessage: {
        period: '',
        type: '',
        value: ''
      }
    };


  },

  methods: {
    async loadCustomers(filter) {

      this.mainApi = `${axios.baseURL2}/customer/all?active=1`;
      if (filter != null) {
        this.filterQuery = `&period=${filter.period}&type=${filter.type}&value=${filter.value}`;
        this.mainApi += `${this.filterQuery}`;
      }
      try {
        let result = await getRequest(this.mainApi);

        this.customers = result.data.users;
        this.pageInfo = result.data.pagination;
      } catch (e) {
        console.error(e);
      }
    },

    validateFilter(status) {
      this.filterMessage = {
        value: "",
        period: "",
        type: ""
      };

      let isValid = true;

      if (!this.tempFilter.value || isNaN(this.tempFilter.value) || Number(this.tempFilter.value) <= 0) {
        this.filterMessage.value = "Please enter a valid number.";
        isValid = false;
      }

      if (!this.tempFilter.period || this.tempFilter.period < 1) {
        this.filterMessage.period = "Please select a period.";
        isValid = false;
      }

      if (status === 'active') {
        if (![1, 2].includes(Number(this.tempFilter.type))) {
          this.filterMessage.type = "Please select a filter type.";
          isValid = false;
        }
      }
      return isValid;
    },

    async loadInactiveCustomers(filter) {
      this.mainInApi = `${axios.baseURL2}/customer/all?disabled=1`;
      if (filter != null) {
        this.filterQuery = `&period=${filter.period}&type=1&value=${filter.value}`;
        this.mainInApi += `${this.filterQuery}`;
      }
      try {
        let result = await getRequest(this.mainInApi);
        this.inactiveCustomers = result.data.users;
        this.pageInfo2 = result.data.pagination;
      } catch (e) {
        console.error(e);
      }
    },

    async handleResetAll(status) {
      this.isLoading = true;

      console.log(this.searchItem);
      console.log(this.searchItem2);
      const request = {
        period: this.filter.period,
        type: this.filter.type,
        value: this.filter.value,
        search: status === 'active' ? this.searchItem : this.searchItem2,
        active: status === 'active' ? 1 : 0,
        disabled: status === 'inactive' ? 1 : 0
      };
      try {
        const response = await postRequest(`${axios.baseURL2}/customer/reset-logout`, request);
        if (response.data.success) {
          swal({
            icon: "success",
            text: response.data.message,
          });
        } else {
          swal({
            icon: "error",
            text: response.data.message,
          });
        }
      } catch (e) {
        console.error(e);
        swal({
          icon: "error",
          text: "An error occurred while resetting accounts.",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async resetAccount(id) {
      const request = {
        id: id
      };
      try {
        let response = await postRequest(`${axios.baseURL2}/customer/reset-logout`, request);
        if (response.data.success) {
          swal({
            icon: "success",
            text: response.data.message,
          });
          this.loadCustomers();
          this.loadInactiveCustomers();
        }
      } catch (e) {
        console.error(e);
      }
    },

    async handleChangeValue(value) {
      this.tempFilter.value = value;
    },

    handleResetFilter() {
      this.tempFilter = { type: 0, period: 0, value: null };
      this.filter = { type: 0, period: 0, value: null };
      this.filterMessage = { value: '', period: '', type: '' };

      // Load unfiltered data
      this.loadCustomers();
      this.loadInactiveCustomers();
    },

    async activeData() {
      // clear json_data
      this.json_data = [];

      let apiUrl = this.downloadApi;
      if (this.filter.value != null) {
        apiUrl += `&period=${this.filter.period}&type=${this.filter.type}&value=${this.filter.value}`;
      }

      let res = await getRequest(apiUrl);

      this.json_data = res.data.users.map(this.exportRow);

      return this.json_data;
    },

    async inactiveData() {
      // clear json_data
      this.json_data = [];

      let apiUrl = this.downloadInactiveApi;
      if (this.filter.value != null) {
        apiUrl += `&period=${this.filter.period}&type=1&value=${this.filter.value}`;
      }

      let res = await getRequest(apiUrl);

      this.json_data = res.data.users.map(this.exportRow);

      return this.json_data;
    },

    exportRow(user) {
      return {
        full_name: user.name,
        ic_number: user.ic_number,
        mobile_number: user.mobile_number,
        username: user.username,
        email: user.email,
        gender: user.gender,
        date_of_birth: user.date_of_birth,
        created_at: user.created_at,
        email_verified: user.email_verified_at != null ? "Yes" : "No",
        declined_reason: user.declined_reason,
        last_login: user.last_login,
        last_logout: user.last_logout,
        reactivated_on: user.reactivated_on,
        reset_at: user.reset_at,
      };
    },

    handleFilter(status) {
      if (!this.validateFilter(status)) {
        return;
      }

      // On success, commit tempFilter → filter
      this.filter = {
        value: this.tempFilter.value,
        period: this.tempFilter.period,
        type: this.tempFilter.type
      };

      // Now load data with committed filter
      if (status === 'active') {
        this.loadCustomers(this.filter);
      } else if (status === 'inactive') {
        this.loadInactiveCustomers(this.filter);
      }
    },

    async handlePageChange(page) {
      this.isLoading = true;

      if (this.searchItem == null || this.searchItem == "") {
        this.mainApi = `${axios.baseURL2}/customer/all?active=1&page=${page}`;
      } else {
        this.mainApi = `${axios.baseURL2}/customer/all?active=1&search=${this.searchItem}&page=${page}`;
        this.downloadApi = `${axios.baseURL2}/customer/all?active=1&export=1&search=${this.searchItem}`;
      }

      if (this.filter.value != null) {
        this.mainApi += `&period=${this.filter.period}&type=${this.filter.type}&value=${this.filter.value}`;
      }

      let result = await getRequest(this.mainApi);


      this.customers = result.data.users;
      this.pageInfo = result.data.pagination;
      this.isLoading = false;
    },

    async handlePageChange2(page) {
      this.isLoading = true;

      if (this.searchItem == null || this.searchItem == "") {
        this.mainInApi = `${axios.baseURL2}/customer/all?disabled=1&page=${page}`;
      } else {
        this.mainInApi = `${axios.baseURL2}/customer/all?disabled=1&search=${this.searchItem}&page=${page}`;
        this.downloadInactiveApi = `${axios.baseURL2}/customer/all?disabled=1&export=1&search=${this.searchItem}`;
      }

      if (this.filter.value != null) {
        this.mainInApi += `&period=${this.filter.period}&value=${this.filter.value}`;
      }

      let result = await getRequest(this.mainInApi);

      this.inactiveCustomers = result.data.users;
      this.pageInfo2 = result.data.pagination;
      this.isLoading = false;
    },

    async searchFor() {
      this.isLoading = true;

      let api_url = `${axios.baseURL2}/customer/all?active=1&search=${this.searchItem}`;
      this.downloadApi = `${axios.baseURL2}/customer/all?active=1&search=${this.searchItem}&export=1`;
      if (this.searchItem == null || this.searchItem == "") {
        api_url = `${axios.baseURL2}/customer/all?active=1`;
      }

      try {
        let result = await getRequest(api_url);

        this.customers = result.data.users;
        this.pageInfo = result.data.pagination;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },

    async searchFor2() {
      this.isLoading = true;
      let api_url = `${axios.baseURL2}/customer/all?disabled=1&search=${this.searchItem2}`;
      this.downloadInactiveApi = `${axios.baseURL2}/customer/all?disabled=1&search=${this.searchItem2}&export=1`;
      if (this.searchItem2.trim() == null || this.searchItem2.trim() == "") {
        api_url = `${axios.baseURL2}/customer/all?disabled=1`;
      }

      try {
        let result = await getRequest(api_url);

        this.inactiveCustomers = result.data.users;
        this.pageInfo2 = result.data.pagination;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },

    customerDetails(user_id, ic_no, email, created_at) {
      localStorage.setItem("email", email);
      localStorage.setItem("created_at", created_at);
      localStorage.setItem("user_det", user_id);
      // return "/customer/" + ic_no;

      this.$router.push("/customer/" + ic_no);
    },

    verifyCustomer(user_id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"],
        }).then((confirm) => {
          if (confirm) {
            axios
              .post(
                axios.baseURL2 + "/customer/verify",
                {
                  user_id: user_id,
                },
                {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .then((res) => {
                const { success, message } = res.data;
                if (success) {
                  swal({
                    text: message,
                    icon: "success",
                  });
                  this.loadCustomers();
                } else {
                  swal({
                    icon: "error",
                    text: message,
                  });
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled",
            });
          }
        });
      }
    },

    handleChangePeriod(value) {
      this.tempFilter.period = value;
    },

    declineVerificationModal(customer) {
      this.user = customer;
      $("#thisModal").modal("show");
    },

    declineVerification() {
      let user_id = this.user.id;
      let reason = this.reason;

      let token = localStorage.getItem("token");
      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"],
        }).then((confirm) => {
          if (confirm) {
            axios
              .post(
                axios.baseURL2 + "/customer/decline",
                {
                  user_id: user_id,
                  reason: reason,
                },
                {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .then((res) => {
                const { success, message } = res.data;
                if (success) {
                  swal({
                    text: message,
                    icon: "success",
                  }).then((success) => {
                    $("#thisModal").modal("hide");
                    this.reason = "";
                  });
                  this.loadCustomers();
                } else {
                  swal({
                    icon: "error",
                    text: message,
                  });
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled",
            });
          }
        });
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      if (token === null || token === "") {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    async reactivateAllAccounts() {
      const request = {
        period: this.filter.period,
        value: this.filter.value,
        search: this.searchItem2,
        active: 0,
        disabled: 1,
      };

      this.isLoading = true;
      try {
        const response = await postRequest(`${axios.baseURL2}/customer/reset-logout`, request);

        if (response.data.success) {
          swal({
            icon: "success",
            text: response.data.message,
          });
          this.loadInactiveCustomers();
        } else {
          swal({
            icon: "error",
            text: response.data.message,
          });
        }
      } catch (error) {
        swal({
          icon: "error",
          text: "An error occurred while reactivating accounts.",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async enableAccount(user_id, disabled_id) {
      try {
        let data = {
          user_id: user_id,
          disabled_id: disabled_id,
        };

        let response = await postRequest(`/users/accounts`, data);

        swal({
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
        });

        response.data.success ? this.loadInactiveCustomers() : "";
      } catch (e) {
        console.error(e);
      }
    },

    async filterDay() {
      this.isLoading = true;

      let api_url = `${axios.baseURL2}/customer/all?active=1&day=${this.data.day}`;
      this.downloadApi = `${axios.baseURL2}/customer/all?active=1&day=${this.data.day}&export=1`;
      if (this.data.day == null || this.data.day == "") {
        api_url = `${axios.baseURL2}/customer/all?active=1`;
      }

      try {
        let result = await getRequest(api_url);

        this.customers = result.data.users;
        this.pageInfo = result.data.pagination;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },

    async filterDayInactive() {
      this.isLoading = true;

      let api_url = `${axios.baseURL2}/customer/all?disabled=1&day=${this.data.dayInactive}`;
      this.downloadInactiveApi = `${axios.baseURL2}/customer/all?disabled=1&day=${this.data.dayInactive}&export=1`;
      if (this.data.dayInactive == null || this.data.dayInactive == "") {
        api_url = `${axios.baseURL2}/customer/all?disabled=1`;
      }

      try {
        let result = await getRequest(api_url);

        this.inactiveCustomers = result.data.users;
        this.pageInfo2 = result.data.pagination;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },

    async resetFilterDay() {
      this.isLoading = true;

      data.day = null;
      data.dayInactive = null;

      await this.loadCustomers();
      await this.loadInactiveCustomers();

      this.isLoading = false;
    }
  },

  beforeMount() { },

  // mounted() {
  //   this.loadCustomers();
  // }

  async created() {
    this.isLoading = true;
    this.tempFilter = { ...this.filter };
    await this.loadCustomers();
    await this.loadInactiveCustomers();
    this.isLoading = false;
  },
};
</script>
